import ModalManager from '@ebay/nice-modal-react';

/**
 * Global Modal Manager
 * https://github.com/eBay/nice-modal-react
 */

export * from '@ebay/nice-modal-react';
export default ModalManager;
